<template>
    <div class="range-datepicker d-inline">
        <b-form-select class="d-inline mb-3 ml-2"
                       v-model="dateRange"
                       :options="dateRangeOptions"
                       @change="dateRangeChanged"/>
        <!--
        <b-btn @click="datePrevious" class="mb-3 px-2 ml-1">&lt;</b-btn>
        <b-btn @click="dateNext" class="mb-3 px-2 ml-1">&gt;</b-btn>
        -->
    </div>
</template>

<script>

// https://designhammer.com/blog/reusable-vuejs-components-part-4-date-range-picker

export default {
    name: 'RangeDatepicker',
    components: {},
    // props: {
    //     dateFrom: {required: true},
    //     dateTo: {required: true},
    // },
    data() {
        return {
            dateRangeOptions: {
                thisweek: this.$i18n.gt('LABEL_RANGE_THISWEEK'),
                thismonth: this.$i18n.gt('LABEL_RANGE_THISMONTH'),
                last7days: this.$i18n.gt('LABEL_RANGE_LAST7DAYS'),
                last30days: this.$i18n.gt('LABEL_RANGE_LAST30DAYS'),
                last60days: this.$i18n.gt('LABEL_RANGE_LAST60DAYS'),
                last90days: this.$i18n.gt('LABEL_RANGE_LAST90DAYS'),
                last180days: this.$i18n.gt('LABEL_RANGE_LAST180DAYS'),
                last365days: this.$i18n.gt('LABEL_RANGE_LAST365DAYS'),
            },
            dateRange: this.$store.state.dateRange

        }
    },
    mounted() {
        if (!this.dateRange) {
            this.dateRange = 'last30days'
            this.dateRangeChanged(this.dateRange)
        }
    },
    methods: {
        computeDates(dateRange) {
            let dateFrom = new Date(),
                dateTo = new Date(),
                day = null
            switch (dateRange) {
                case 'thisweek':
                    day = dateFrom.getDay()
                    dateFrom.setDate(dateFrom.getDate() - day + (day ? 1 : -6))
                    dateTo.setDate(dateFrom.getDate() + 6)
                    break
                case 'last7days':
                    dateFrom.setDate(dateFrom.getDate() - 6)
                    break
                case 'thismonth':
                    dateFrom = new Date(dateFrom.getFullYear(), dateFrom.getMonth(), 1)
                    dateTo = new Date(dateTo.getFullYear(), dateTo.getMonth() + 1, 0)
                    break
                case 'last30days':
                    dateFrom.setDate(dateFrom.getDate() - 30)
                    break
                case 'last60days':
                    dateFrom.setDate(dateFrom.getDate() - 60)
                    break
                case 'last90days':
                    dateFrom.setDate(dateFrom.getDate() - 90)
                    break
                case 'last180days':
                    dateFrom.setDate(dateFrom.getDate() - 182)
                    break
                case 'last365days':
                    dateFrom.setDate(dateFrom.getDate() - 365)
                    break
                default:
                    console.log('RangeDatepicker:computeDates  unknown dateRange "' + dateRange + '"')
                    return null
            }
            const pad = n => `${Math.floor(Math.abs(n))}`.padStart(2, '0')
            const isoShort = d => `${pad(d.getFullYear())}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
            // const tzOffset = -dateFrom.getTimezoneOffset()
            // const tzDiff = (tzOffset >= 0) ? '+' : '-'
            // const tzValue = `${pad(tzOffset / 60)}:${pad(tzOffset % 60)}`
            // return {
            //     from: isoShort(dateFrom) + 'T00:00:00' + tzDiff + tzValue,
            //     to: isoShort(dateTo) + 'T23:59:59' + tzDiff + tzValue
            // }
            return {
                from: isoShort(dateFrom),
                to: isoShort(dateTo)
            }
        },
        dateRangeChanged(dateRange) {
            if (dateRange) {
                // persist
                this.$store.state.dateRange = dateRange
                // convert to actual dates
                let dates = this.computeDates(dateRange)
                if (dates)
                    this.$emit('input', dates)
            }
        },
    }
}

</script>

<style lang="scss">
.range-datepicker {
    select {
        width: auto;
    }
}
</style>
